
    <!-- <div class="links" style="text-align: right; padding: 1rem;">
        <a class="btn" href="/subscription">Subscription</a>
    </div> -->

    <div class="loader_session"  *ngIf='loaderdata'>
      <div class="loader-4"><span></span>
    </div>
    </div>
 <div class="my-4">   
<h4>Subscription</h4>
<p *ngIf="checksub" style="color:red;font-weight:600;font-size: 1.3rem;">* Account on hold please choose a plan to continue.</p>
</div>
  <table class="table table-bordered">
    <thead class="thead-dark"> 
      <tr>
        <th>LEVEL NAME</th>
        <th>STATUS</th>
        <th>ACCESS</th>
        <th>RECURRING</th>
        <th>AMOUNT</th>
      </tr>
    </thead>
    <tbody>
      <ng-template ngFor let-item [ngForOf]="sub" >
      <tr>
        <td>{{item.SUB_NAME}}</td>
        <td>{{item.SUB_STATUS}}</td>
        <td>{{item.SUB_ACCESS}}</td>
        <td>{{item.SUB_RECCURENT}}</td>
        <td>{{item.AMOUNT}} USD</td>
      </tr>
      </ng-template>
    </tbody>
  </table>
    

  <div class="row my-5">
    <div class="col-md-4">
    

      <div class="reg-membership">
        <form  #usauserlogin="ngForm" (ngSubmit)="onClickSubmitSub(usauserlogin.value)" >
          <div class="reg-elements">
            <div class="heading">
              <h4>{{subpackage[0]?.planname}}</h4>
              <p>USA Membership</p>
            </div>
            <input type="hidden" name="planname"  [ngModel]="1"  >
    
        <div class="rate">
          <h1 >${{subpackage[0]?.usa}}</h1>
        </div>
        <div class="up-btns">
          <input class="btn-sub"  type="submit" value="submit">
        </div>
      </div>
      <div class="donations-session">
        <select class="donations-elements form-select fullsize mb-3" aria-label="" name="Donation" [ngModel]>
          <option [ngValue]="null" [disabled]="true" [selected]='true'>Donation</option>
          <option value="0">$0</option>
          <option value="10">$10</option>
          <option value="25">$25</option>
          <option value="50">$50</option>
          <option value="100">$100</option>
        </select>
      </div>


      </form>
    </div>
    </div>

    <div class="col-md-4">
             
      <div class="reg-membership">
        <form  #canadauserlogin="ngForm" (ngSubmit)="onClickSubmitSub(canadauserlogin.value)" >
          <div class="reg-elements">
            <div class="heading">
              <h4>{{subpackage[0]?.planname}}</h4>
              <p>Canada / Mexico Membership</p>
            </div>
            <input type="hidden" name="planname"   [ngModel]="2"  >

        <div class="rate">
          <h1 >${{subpackage[0]?.canada}}</h1>
        </div>
        <div class="up-btns">
          <input class="btn-sub"  type="submit" value="submit">
        </div>
      </div>
      <div class="donations-session">
        <select class="donations-elements form-select fullsize mb-3" aria-label="" name="Donation" [ngModel]>
          <option [ngValue]="null" [disabled]="true" [selected]='true'>Donation</option>
          <option value="0">$0</option>
          <option value="10">$10</option>
          <option value="25">$25</option>
          <option value="50">$50</option>
          <option value="100">$100</option>
        </select>
      </div>


      </form>
    </div>
    </div>
    <div class="col-md-4">
             
      <div class="reg-membership">
        <form  #restofworlduserlogin="ngForm" (ngSubmit)="onClickSubmitSub(restofworlduserlogin.value)" >
          <div class="reg-elements">
            <div class="heading">
              <h4>{{subpackage[0]?.planname}}</h4>
              <p> Rest of World</p>
            </div>
            <input type="hidden" name="planname"   [ngModel]="3"  >

        <div class="rate">
          <h1 >${{subpackage[0]?.other}}</h1>
        </div>
        <div class="up-btns">
          <input class="btn-sub"  type="submit" value="submit">
        </div>
      </div>
      <div class="donations-session">
        <select class="donations-elements form-select fullsize mb-3" aria-label="" name="Donation" [ngModel]>
          <option [ngValue]="null" [disabled]="true" [selected]='true'>Donation</option>
          <option value="0">$0</option>
          <option value="10">$10</option>
          <option value="25">$25</option>
          <option value="50">$50</option>
          <option value="100">$100</option>
        </select>
      </div>


      </form>
    </div>
    </div>
  </div>